<template>
  <div class="job-list">
    <el-table ref="multipleTable" :data="jobData" tooltip-effect="dark" style="width: 100%" class="common-edit-button"
      @selection-change="handleSelectionChange">
      <!-- <el-table-column label="#" type="index"> </el-table-column> -->
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->
      <el-table-column prop="jobName" label="职务名称" :show-overflow-tooltip="true">
      </el-table-column>
      <!-- <el-table-column
        prop="title"
        label="状态"
        :show-overflow-tooltip="true"
        width="150px"
      >
        <template slot-scope="scope">
          {{ scope.row.status }}
        </template>
</el-table-column> -->
      <!-- <el-table-column
        prop="createTime"
        label="创建时间"
        :show-overflow-tooltip="true"
      >
      </el-table-column> -->
      <el-table-column label="操作" width="380px">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- 查看绑定教师 -->
            <!-- <el-button type="success" @click="bindTeacherList(scope.row)" v-hasPermi="'sc:teachersjob:list'"
              size="small">
              查看绑定教师
            </el-button> -->
            <!-- 绑定教师 -->
            <el-button type="success" @click="bindTeacher(scope.row)" v-hasPermi="'sc:teachersjob:list'" size="small">
              职务绑定
            </el-button>
            <!-- 绑定菜单 -->
            <el-button type="success" @click="bindMenu(scope.row)" v-hasPermi="'sc:jobmenu:list'"
              :disabled="scope.row.jobName == '系统管理员'" size="small">
              功能绑定
            </el-button>
            <!-- 修改 -->
            <el-button type="warning" icon="el-icon-edit" @click="editjob(scope.row)" v-hasPermi="'sc:schooljob:edit'"
              :disabled="scope.row.jobName == '系统管理员'" size="small">修改
            </el-button>
            <!-- 删除 -->
            <el-button type="danger" icon="el-icon-delete" @click="deljob(scope.row)" v-hasPermi="'sc:schooljob:delete'"
              :disabled="scope.row.jobName == '系统管理员'" size="small">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 修改 -->
    <editJob :editShow.sync="editShow" v-show="editShow" :jobItemData="jobItemData" />
    <bindTeacherDialog :bindShow.sync="bindShow" v-if="bindShow" :jobItemData="jobItemData" @delSubmit="delSubmit"
    />
    <bindTeacherListDialog :bindTeacherShow.sync="bindTeacherShow" v-if="bindTeacherShow" :jobItemData="jobItemData" />
    <bindMenuDialog :bindShow.sync="bindMenuShow" v-if="bindMenuShow" :menuList="menuData" :jobItemData="jobItemData"
      :jobMenuIds="jobMenuIds" @bindMenuSubmit="bindMenuSubmit" />
  </div>
</template>

<script>
import editJob from "../edit-job/edit-job.vue";
import bindTeacherDialog from "../bind-teacher/bind-teacher.vue";
import bindTeacherListDialog from "../bind-teacher-list/bind-teacher-list.vue";
import bindMenuDialog from "../bind-menu/bind-menu";

export default {
  data() {
    return {
      editShow: false, // 修改表单显示
      bindShow: false, // 绑定表单显示
      bindTeacherShow: false,
      jobItemData: null, // 职务详情数据
      teacherIds: [],
      bindMenuShow: false,
      jobMenuIds: [],
      firstOpen: true
    };
  },
  inject: ["refresh"],
  props: {
    // 职务详情数据
    jobData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    menuData: {
      type: Array,
    },
  },
  components: {
    editJob,
    bindTeacherDialog,
    bindMenuDialog,
    bindTeacherListDialog
  },
  created() { },
  methods: {
    // 绑定功能菜单
    bindMenuSubmit(data) {
      this.post(this.$url.insertJobMenuBath, {
        jobId: data.jobId,
        menuIds: data.menuIds,
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success("绑定成功");
          this.bindMenuShow = false;
          // 刷新列表
          // this.refresh();
        } else {
          this.$message.error("绑定失败，请稍后重试");
        }
      });
    },
    // 清空绑定教师
    delSubmit(data) {
      this.delete(this.$url.clearJobBindTeacher, data).then((res) => {
        if (res.code == 200) {
          this.$message.success("清空成功");
          // this.bindShow = false;
          // 刷新列表
          // this.refresh();
        } else {
          this.$message.error("清空失败，请稍后重试");
        }
      });
    },
    // 获取职务绑定菜单列表
    getJobMenu(id) {
      this.get(this.$url.getJobMenu + "/" + id).then((res) => {
        // console.log("获取职务绑定菜单列表==>", res);
        this.jobMenuIds = res.data;
        this.bindMenuShow = true;
      });
    },
    bindMenu(item) {
      this.jobItemData = item;
      this.getJobMenu(item.id);
    },
    // 职务绑定教师
    bindTeacher(item) {
      this.bindShow = true;
      this.jobItemData = item;
    },
    bindTeacherList(item) {
      this.bindTeacherShow = true;
      this.jobItemData = item;
    },
    // 列表数据切换选中时调用，用于批量删除
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
      let list = [];
      this.selectList.forEach((item) => {
        list.push(item.id);
      });
      this.$emit("multipleDelete", list);
    },
    // addjob(e) {},
    editjob(item) {
      this.editShow = true;
      this.jobItemData = item;
    },
    deljob(item) {
      this.$confirm("是否删除该数据项?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除学生信息接口
          //  let list = [];
          // list.push(item.id);
          this.delete(this.$url.deleteSchoolJob + "?jobId=" + item.id)
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error("删除失败，请稍后重试");
              }
            })
            .catch((err) => {
              console.log(err);
              // this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => { });
    },
  },
};
</script>

<style>
@import "./jobList.scss";
</style>
